export default __webpack_public_path__ + "static/media/logo-v2-centered.f2e89ee0.svg";